import React, {useState} from 'react';

const ContactSalesForm = () => {

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    companyName: '',
    country: '',
    projectedMonthlyVolume: '',
    industry: '',
    companyWebsite: '',
    isEcommercePlatform: '',
    businessDescription: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' or 'error'

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const apiUrl = 'https://qjp28pe7h4.execute-api.us-east-1.amazonaws.com/prod/sales_request/create';

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

//      const data = await response.json();
//      console.log('Success:', data);
      console.log('Success');
      setSubmitStatus('success');
      // Reset form after successful submission if needed
      setFormData({ firstName: '', lastName: '', phone: '', email: '', companyName: '', country: '',
        projectedMonthlyVolume: '', industry: '', companyWebsite: '', isEcommercePlatform: '', businessDescription: ''});
    } catch (error) {
      console.error('Error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section
        className='contact-us-form pt-60 pb-120'
        style={{
          background:
            "url('assets/img/shape/contact-us-bg.svg')no-repeat center bottom",
        }}
      >
        <div className='container'>
          <div className='row justify-content-lg-between align-items-center'>
            <div className='col-lg-6 col-md-8'>
              <div className='section-heading'>
                <h2>Contact Sales</h2>
                <p>
                  We’d love to learn about your business! Simply fill out the form and a member of our team will be in touch.
                </p>
              </div>
              <form onSubmit={handleSubmit} className='register-form'>
                <div className='row'>
                  <div className='col-sm-6'>
                    <label htmlFor='firstName' className='mb-1'>
                      First name <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <input
                        type='text'
                        className='form-control'
                        id='firstName'
                        required
                        placeholder='First name'
                        aria-label='First name'
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className='col-sm-6 '>
                    <label htmlFor='lastName' className='mb-1'>
                      Last name <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <input
                        type='text'
                        className='form-control'
                        id='lastName'
                        placeholder='Last name'
                        aria-label='Last name'
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className='col-sm-6'>
                    <label htmlFor='phone' className='mb-1'>
                      Work Phone Number <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <input
                        type='text'
                        className='form-control'
                        id='phone'
                        required
                        placeholder='Phone'
                        aria-label='Phone'
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className='col-sm-6'>
                    <label htmlFor='email' className='mb-1'>
                      Work Email <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <input
                        type='email'
                        className='form-control'
                        id='email'
                        required
                        placeholder='Email'
                        aria-label='Email'
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className='col-sm-6'>
                    <label htmlFor='companyName' className='mb-1'>
                      Company Name <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <input
                          type='text'
                          className='form-control'
                          id='companyName'
                          required
                          placeholder='Company name'
                          aria-label='companyName'
                          value={formData.companyName}
                          onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className='col-sm-6'>
                    <label htmlFor='country' className='mb-1'>
                      Country <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <select
                          className='form-control form-select'
                          name='country'
                          id='country'
                          required=''
                          data-msg='Please select your country.'
                          defaultValue='Default'
                          value={formData.country}
                          onChange={handleChange}
                      >
                        <option value=''>Select Country</option>
                        <option value='AF'>Afghanistan</option>
                        <option value='AX'>Åland Islands</option>
                        <option value='AL'>Albania</option>
                        <option value='DZ'>Algeria</option>
                        <option value='AS'>American Samoa</option>
                        <option value='AD'>Andorra</option>
                        <option value='AO'>Angola</option>
                        <option value='AI'>Anguilla</option>
                        <option value='AQ'>Antarctica</option>
                        <option value='AG'>Antigua and Barbuda</option>
                        <option value='AR'>Argentina</option>
                        <option value='AM'>Armenia</option>
                        <option value='AW'>Aruba</option>
                        <option value='AU'>Australia</option>
                        <option value='AT'>Austria</option>
                        <option value='AZ'>Azerbaijan</option>
                        <option value='BS'>Bahamas</option>
                        <option value='BH'>Bahrain</option>
                        <option value='BD'>Bangladesh</option>
                        <option value='BB'>Barbados</option>
                        <option value='BY'>Belarus</option>
                        <option value='BE'>Belgium</option>
                        <option value='BZ'>Belize</option>
                        <option value='BJ'>Benin</option>
                        <option value='BM'>Bermuda</option>
                        <option value='BT'>Bhutan</option>
                        <option value='BO'>Bolivia, Plurinational State of</option>
                        <option value='BQ'>Bonaire, Sint Eustatius and Saba</option>
                        <option value='BA'>Bosnia and Herzegovina</option>
                        <option value='BW'>Botswana</option>
                        <option value='BV'>Bouvet Island</option>
                        <option value='BR'>Brazil</option>
                        <option value='IO'>British Indian Ocean Territory</option>
                        <option value='BN'>Brunei Darussalam</option>
                        <option value='BG'>Bulgaria</option>
                        <option value='BF'>Burkina Faso</option>
                        <option value='BI'>Burundi</option>
                        <option value='KH'>Cambodia</option>
                        <option value='CM'>Cameroon</option>
                        <option value='CA'>Canada</option>
                        <option value='CV'>Cape Verde</option>
                        <option value='KY'>Cayman Islands</option>
                        <option value='CF'>Central African Republic</option>
                        <option value='TD'>Chad</option>
                        <option value='CL'>Chile</option>
                        <option value='CN'>China</option>
                        <option value='CX'>Christmas Island</option>
                        <option value='CC'>Cocos (Keeling) Islands</option>
                        <option value='CO'>Colombia</option>
                        <option value='KM'>Comoros</option>
                        <option value='CG'>Congo</option>
                        <option value='CD'>
                          Congo, the Democratic Republic of the
                        </option>
                        <option value='CK'>Cook Islands</option>
                        <option value='CR'>Costa Rica</option>
                        <option value='CI'>Côte d'Ivoire</option>
                        <option value='HR'>Croatia</option>
                        <option value='CU'>Cuba</option>
                        <option value='CW'>Curaçao</option>
                        <option value='CY'>Cyprus</option>
                        <option value='CZ'>Czech Republic</option>
                        <option value='DK'>Denmark</option>
                        <option value='DJ'>Djibouti</option>
                        <option value='DM'>Dominica</option>
                        <option value='DO'>Dominican Republic</option>
                        <option value='EC'>Ecuador</option>
                        <option value='EG'>Egypt</option>
                        <option value='SV'>El Salvador</option>
                        <option value='GQ'>Equatorial Guinea</option>
                        <option value='ER'>Eritrea</option>
                        <option value='EE'>Estonia</option>
                        <option value='ET'>Ethiopia</option>
                        <option value='FK'>Falkland Islands (Malvinas)</option>
                        <option value='FO'>Faroe Islands</option>
                        <option value='FJ'>Fiji</option>
                        <option value='FI'>Finland</option>
                        <option value='FR'>France</option>
                        <option value='GF'>French Guiana</option>
                        <option value='PF'>French Polynesia</option>
                        <option value='TF'>French Southern Territories</option>
                        <option value='GA'>Gabon</option>
                        <option value='GM'>Gambia</option>
                        <option value='GE'>Georgia</option>
                        <option value='DE'>Germany</option>
                        <option value='GH'>Ghana</option>
                        <option value='GI'>Gibraltar</option>
                        <option value='GR'>Greece</option>
                        <option value='GL'>Greenland</option>
                        <option value='GD'>Grenada</option>
                        <option value='GP'>Guadeloupe</option>
                        <option value='GU'>Guam</option>
                        <option value='GT'>Guatemala</option>
                        <option value='GG'>Guernsey</option>
                        <option value='GN'>Guinea</option>
                        <option value='GW'>Guinea-Bissau</option>
                        <option value='GY'>Guyana</option>
                        <option value='HT'>Haiti</option>
                        <option value='HM'>
                          Heard Island and McDonald Islands
                        </option>
                        <option value='VA'>Holy See (Vatican City State)</option>
                        <option value='HN'>Honduras</option>
                        <option value='HK'>Hong Kong</option>
                        <option value='HU'>Hungary</option>
                        <option value='IS'>Iceland</option>
                        <option value='IN'>India</option>
                        <option value='ID'>Indonesia</option>
                        <option value='IR'>Iran, Islamic Republic of</option>
                        <option value='IQ'>Iraq</option>
                        <option value='IE'>Ireland</option>
                        <option value='IM'>Isle of Man</option>
                        <option value='IL'>Israel</option>
                        <option value='IT'>Italy</option>
                        <option value='JM'>Jamaica</option>
                        <option value='JP'>Japan</option>
                        <option value='JE'>Jersey</option>
                        <option value='JO'>Jordan</option>
                        <option value='KZ'>Kazakhstan</option>
                        <option value='KE'>Kenya</option>
                        <option value='KI'>Kiribati</option>
                        <option value='KP'>
                          Korea, Democratic People's Republic of
                        </option>
                        <option value='KR'>Korea, Republic of</option>
                        <option value='KW'>Kuwait</option>
                        <option value='KG'>Kyrgyzstan</option>
                        <option value='LA'>Lao People's Democratic Republic</option>
                        <option value='LV'>Latvia</option>
                        <option value='LB'>Lebanon</option>
                        <option value='LS'>Lesotho</option>
                        <option value='LR'>Liberia</option>
                        <option value='LY'>Libya</option>
                        <option value='LI'>Liechtenstein</option>
                        <option value='LT'>Lithuania</option>
                        <option value='LU'>Luxembourg</option>
                        <option value='MO'>Macao</option>
                        <option value='MK'>
                          Macedonia, the former Yugoslav Republic of
                        </option>
                        <option value='MG'>Madagascar</option>
                        <option value='MW'>Malawi</option>
                        <option value='MY'>Malaysia</option>
                        <option value='MV'>Maldives</option>
                        <option value='ML'>Mali</option>
                        <option value='MT'>Malta</option>
                        <option value='MH'>Marshall Islands</option>
                        <option value='MQ'>Martinique</option>
                        <option value='MR'>Mauritania</option>
                        <option value='MU'>Mauritius</option>
                        <option value='YT'>Mayotte</option>
                        <option value='MX'>Mexico</option>
                        <option value='FM'>Micronesia, Federated States of</option>
                        <option value='MD'>Moldova, Republic of</option>
                        <option value='MC'>Monaco</option>
                        <option value='MN'>Mongolia</option>
                        <option value='ME'>Montenegro</option>
                        <option value='MS'>Montserrat</option>
                        <option value='MA'>Morocco</option>
                        <option value='MZ'>Mozambique</option>
                        <option value='MM'>Myanmar</option>
                        <option value='NA'>Namibia</option>
                        <option value='NR'>Nauru</option>
                        <option value='NP'>Nepal</option>
                        <option value='NL'>Netherlands</option>
                        <option value='NC'>New Caledonia</option>
                        <option value='NZ'>New Zealand</option>
                        <option value='NI'>Nicaragua</option>
                        <option value='NE'>Niger</option>
                        <option value='NG'>Nigeria</option>
                        <option value='NU'>Niue</option>
                        <option value='NF'>Norfolk Island</option>
                        <option value='MP'>Northern Mariana Islands</option>
                        <option value='NO'>Norway</option>
                        <option value='OM'>Oman</option>
                        <option value='PK'>Pakistan</option>
                        <option value='PW'>Palau</option>
                        <option value='PS'>Palestinian Territory, Occupied</option>
                        <option value='PA'>Panama</option>
                        <option value='PG'>Papua New Guinea</option>
                        <option value='PY'>Paraguay</option>
                        <option value='PE'>Peru</option>
                        <option value='PH'>Philippines</option>
                        <option value='PN'>Pitcairn</option>
                        <option value='PL'>Poland</option>
                        <option value='PT'>Portugal</option>
                        <option value='PR'>Puerto Rico</option>
                        <option value='QA'>Qatar</option>
                        <option value='RE'>Réunion</option>
                        <option value='RO'>Romania</option>
                        <option value='RU'>Russian Federation</option>
                        <option value='RW'>Rwanda</option>
                        <option value='BL'>Saint Barthélemy</option>
                        <option value='SH'>
                          Saint Helena, Ascension and Tristan da Cunha
                        </option>
                        <option value='KN'>Saint Kitts and Nevis</option>
                        <option value='LC'>Saint Lucia</option>
                        <option value='MF'>Saint Martin (French part)</option>
                        <option value='PM'>Saint Pierre and Miquelon</option>
                        <option value='VC'>Saint Vincent and the Grenadines</option>
                        <option value='WS'>Samoa</option>
                        <option value='SM'>San Marino</option>
                        <option value='ST'>Sao Tome and Principe</option>
                        <option value='SA'>Saudi Arabia</option>
                        <option value='SN'>Senegal</option>
                        <option value='RS'>Serbia</option>
                        <option value='SC'>Seychelles</option>
                        <option value='SL'>Sierra Leone</option>
                        <option value='SG'>Singapore</option>
                        <option value='SX'>Sint Maarten (Dutch part)</option>
                        <option value='SK'>Slovakia</option>
                        <option value='SI'>Slovenia</option>
                        <option value='SB'>Solomon Islands</option>
                        <option value='SO'>Somalia</option>
                        <option value='ZA'>South Africa</option>
                        <option value='GS'>
                          South Georgia and the South Sandwich Islands
                        </option>
                        <option value='SS'>South Sudan</option>
                        <option value='ES'>Spain</option>
                        <option value='LK'>Sri Lanka</option>
                        <option value='SD'>Sudan</option>
                        <option value='SR'>Suriname</option>
                        <option value='SJ'>Svalbard and Jan Mayen</option>
                        <option value='SZ'>Swaziland</option>
                        <option value='SE'>Sweden</option>
                        <option value='CH'>Switzerland</option>
                        <option value='SY'>Syrian Arab Republic</option>
                        <option value='TW'>Taiwan, Province of China</option>
                        <option value='TJ'>Tajikistan</option>
                        <option value='TZ'>Tanzania, United Republic of</option>
                        <option value='TH'>Thailand</option>
                        <option value='TL'>Timor-Leste</option>
                        <option value='TG'>Togo</option>
                        <option value='TK'>Tokelau</option>
                        <option value='TO'>Tonga</option>
                        <option value='TT'>Trinidad and Tobago</option>
                        <option value='TN'>Tunisia</option>
                        <option value='TR'>Turkey</option>
                        <option value='TM'>Turkmenistan</option>
                        <option value='TC'>Turks and Caicos Islands</option>
                        <option value='TV'>Tuvalu</option>
                        <option value='UG'>Uganda</option>
                        <option value='UA'>Ukraine</option>
                        <option value='AE'>United Arab Emirates</option>
                        <option value='GB'>United Kingdom</option>
                        <option value='US'>United States</option>
                        <option value='UM'>
                          United States Minor Outlying Islands
                        </option>
                        <option value='UY'>Uruguay</option>
                        <option value='UZ'>Uzbekistan</option>
                        <option value='VU'>Vanuatu</option>
                        <option value='VE'>
                          Venezuela, Bolivarian Republic of
                        </option>
                        <option value='VN'>Viet Nam</option>
                        <option value='VG'>Virgin Islands, British</option>
                        <option value='VI'>Virgin Islands, U.S.</option>
                        <option value='WF'>Wallis and Futuna</option>
                        <option value='EH'>Western Sahara</option>
                        <option value='YE'>Yemen</option>
                        <option value='ZM'>Zambia</option>
                        <option value='ZW'>Zimbabwe</option>
                      </select>
                    </div>
                  </div>

                  <div className='col-sm-12'>
                    <label htmlFor='projectedMonthlyVolume' className='mb-1'>
                      My monthly projected monthly volume <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <select
                          className='form-control form-select'
                          name='projectedMonthlyVolume'
                          id='projectedMonthlyVolume'
                          required=''
                          data-msg='Please select your projected monthly volume.'
                          value={formData.projectedMonthlyVolume}
                          onChange={handleChange}
                      >
                        <option value=''>My projected monthly processing is between...*</option>
                        <option value='0 to 10 000'>$0 to $10,000</option>
                        <option value='10 001 to 50 000'>$10,000 to $50,000</option>
                        <option value='50 001 to 100 000'>$50,000 to $100,000</option>
                        <option value='100 001 to 250 000'>$100,000 to $250,000</option>
                        <option value='250 001 to 1 000 000'>$250,000 to $1,000,000</option>
                        <option value='over 1 000 001'>$1,000,000 or more</option>
                      </select>
                    </div>
                  </div>

                  <div className='col-sm-12'>
                    <label htmlFor='industry' className='mb-1'>
                      Industry <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <select
                          className='form-control form-select'
                          name='industry'
                          id='industry'
                          required=''
                          data-msg='Please select your Industry.'
                          value={formData.industry}
                          onChange={handleChange}
                      >
                        <option value=''>Please select your Industry.</option>
                        <option value='Airlines'>Airlines</option>
                        <option value='Digital Content'>Digital Content</option>
                        <option value='Education'>Education</option>
                        <option value='Financial Services'>Financial Services</option>
                        <option value='Forex'>Forex</option>
                        <option value='Gambling'>Gambling</option>
                        <option value='Gaming'>Gaming</option>
                        <option value='Hospitality'>Hospitality</option>
                        <option value='Restaurant POS'>Restaurant POS</option>
                        <option value='Retail'>Retail</option>
                        <option value='Retail POS'>Retail POS</option>
                        <option value='Travel'>Travel</option>
                        <option value='Other'>Other</option>
                      </select>
                    </div>
                  </div>

                  <div className='col-sm-12'>
                    <label htmlFor='companyWebsite' className='mb-1'>
                      Website URL <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <input
                          type='companyWebsite'
                          className='form-control'
                          id='companyWebsite'
                          required
                          placeholder='URL'
                          aria-label='companyWebsite'
                          value={formData.companyWebsite}
                          onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className='col-sm-12'>
                    <label htmlFor='isEcommercePlatform' className='mb-1'>
                      Do you use eCommerce platform? <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <select
                          className='form-control form-select'
                          name='isEcommercePlatform'
                          id='isEcommercePlatform'
                          required=''
                          data-msg='Do you use eCommerce platform?'
                          value={formData.isEcommercePlatform}
                          onChange={handleChange}
                      >
                        <option value=''>Do you use eCommerce platform?</option>
                        <option value='budget1'>Yes</option>
                        <option value='budget1'>No</option>
                      </select>
                    </div>
                  </div>

                  <div className='col-12'>
                    <label htmlFor='businessDescription' className='mb-1'>
                      Tell us more about your business and the type of payments you're looking to accept so we can give you a tailored response. <span className='text-danger'>*</span>
                    </label>
                    <div className='input-group mb-3'>
                      <textarea
                        className='form-control'
                        id='businessDescription'
                        required
                        placeholder='Describe your business'
                        style={{ height: '120px' }}
                        value={formData.businessDescription}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <button type='submit' className='btn btn-primary mt-4' disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>

                {submitStatus === 'success' && (
                    <div className="alert alert-success mt-3">
                      Form submitted successfully!
                    </div>
                )}
                {submitStatus === 'error' && (
                    <div className="alert alert-danger mt-3">
                      There was an error submitting the form. Please try again.
                    </div>
                )}
              </form>
            </div>
            <div className='col-lg-5 col-md-10'>
              <div className='contact-us-img'>
                <img
                  src='assets/img/contact-us-img-2.svg'
                  alt='contact us'
                  className='img-fluid'
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSalesForm;
